import { EventEmitter, inject, Injectable, Injector } from '@angular/core';
import { debounceTime, filter, map, Observable, scan } from 'rxjs';

import type { VideoInfo, VideoSnippet } from '../_mappers/snippet.mapper';
import { SnippetMapper } from '../_mappers/snippet.mapper';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class VideoDsService {
  private readonly injector = inject(Injector);
  private readonly document = inject(DOCUMENT);

  videoInfoEvent = new EventEmitter<VideoInfo>();

  dispatchVideoInfo(event: VideoInfo): void {
    this.videoInfoEvent.emit(event);
  }

  loadVideoSnippets(brand: string): Observable<VideoSnippet[]> {
    return this.videoInfoEvent.pipe(
      filter((video) => !!video),
      scan((acc, video) => {
        return [...acc, video].filter((value, index, self) => (
          index === self.findIndex((t) => t.videoId === value.videoId)
        ));
      }, [] as VideoInfo[]),
      debounceTime(1000),
      map((videos) => {
        const snippetMapper = this.injector.get(SnippetMapper);

        return videos.map((video) => snippetMapper.mapVideoSnippet(
          video,
          brand + ' | ' + (video.videoTitle ?? 'Video ' + videos.length),
          this.document.location.origin
        ));
      })
    );
  }
}
